import BaseModel from './BaseModel';

export default class Publication extends BaseModel {
  constructor(data = {}) {
    super(Publication, data);
    this.id = data.id;
    this.abstract = data.abstract;
    this.authors = data.authors;
    this.placePublished = data.placePublished;
    this.title = data.title;
    this.year = data.year;
    this.doi = data.doi;
  }

  firstAuthor() {
    return this.authors && this.authors.length > 0
      ? this.authors[0]
      : '';
  }

  firstAuthorSeparator() {
    return this.authors.length > 1 ? ';' : '.';
  }

  remainingAuthorList() {
    return this.authors
      ? this.authors
          .filter((author) => author !== this.firstAuthor())
          .join('; ') + '.'
      : '';
  }

  doiIsLink() {
    return /https?:/.test(this.doi);
  }

  doiLink() {
    return this.doiIsLink()
      ? this.doi
      : `https://doi.org/${this.doi}`;
  }
}
